module.exports = __webpack_public_path__ + "static/media/lensor.1366846e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/lensor.webp
// module id = 750
// module chunks = 0